<template>
  <div class="content">
    <div class="bottom">
      <div class="box" v-if="is_status == 1">
        <div class="option">
          <div class="optionLeft">
            <div>
              国内剩余（条）
              <el-button
                type="text"
                @click="$router.push({ path: 'message-recharge' })"
                >去充值</el-button
              >
            </div>
            <h2>0</h2>
          </div>
          <div class="optionLeft"></div>
        </div>
        <table class="cards">
          <thead class="thead">
            <tr>
              <th>消息类别</th>
              <th>消息标题</th>
              <th>推送规则</th>
              <th>公众号模版消息</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="2" class="tdH">订单消息</td>
              <td>消费通知</td>
              <td>买单收款支付成功</td>
              <td>$100</td>
            </tr>
            <tr>
              <td>退款结果通知</td>
              <td>
                服务项目/卡项/服务套餐/买单收款/APP收款退款成功/失败通知/拒绝退款
              </td>
              <td>$80</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      is_status: 1,
      page: 0,
      total: 0
    };
  },
  mounted() {
    if (this.$route.query.jude) {
      this.is_status = this.$route.query.jude;
    }
  },
  methods: {
    addSlice(index) {
      this.$router.push({
        path: `adSign?jude=${index}`
      });
    },
    // 分頁
    handleCurrentChange(val) {
      console.log("val", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  background: #fff;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 56px;
    font-size: 14px;
    color: #595961;
    line-height: 34px;
    padding: 11px 0;
    display: flex;
    .btn {
      width: 100px;
      height: 36px;
      text-align: center;
      border-radius: 6px;
      margin-right: 5px;
      cursor: pointer;
    }
    .btnCurrent {
      color: #fff;
      background: #2589ff;
    }
  }
  .bottom {
    flex: 1;
    overflow-y: auto;

    .box {
      background: #f2f2f6;
      border-radius: 6px;
      padding: 10px;
    }
    .option {
      width: 100%;
      padding: 10px 20px;
      background-color: #fff !important;
      color: #595961;
      height: 117px;
      margin-bottom: 10px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      > div {
        width: 100%;
        text-align: center;
        padding-top: 10px;
      }
    }
    .cards {
      width: 100%;
      padding-top: 15px;
      padding-bottom: 15px;
      background-color: #fff;
      border-radius: 6px;
      margin-bottom: 10px;
      .thead {
        tr {
          height: 49px;
          text-align: left;
          th {
            padding: 15px 15px;
          }
        }
      }
      tbody {
        tr {
          border-top: 1px solid #eee;

          td {
            padding: 15px;
          }
          .tdH {
            border-right: 1px solid #eee;
          }
        }
      }
    }
  }
  .el-pagination {
    padding-top: 20px;
    height: 60px;
    border-top: 1px solid #eee;
  }
}
</style>
